import { gsap, ScrollToPlugin } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { throttle } from 'lodash'
gsap.registerPlugin(ScrollToPlugin); 

export default class bodyScroll {
  
  
  constructor() {
    // header = document.querySelector(".primary-header");
    lastScroll = 0;
  }
  
  static init() {
    window.addEventListener('scroll', throttle(this.addScrollClass, 50));


 
 

 
  }
  
  static addScrollClass() {


    const body = document.body; 
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";

    
   
   
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 150) {
        body.classList.remove(scrollUp);
        return;
      }
      
      if (currentScroll > this.lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } else if (currentScroll < this.lastScroll && body.classList.contains(scrollDown)) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      this.lastScroll = currentScroll;

    
    
    const header = document.querySelector(".primary-header");
    // const scrolled = header.offsetTop;
    const scrolled = 100;
    
    if (window.pageYOffset > scrolled) {
      document.body.classList.add("scrolled");
    }
    else {
      document.body.classList.remove("scrolled");
    }
    
  }
  
}